import { render, staticRenderFns } from "./BodySkeleton.vue?vue&type=template&id=141b33ae"
import script from "./BodySkeleton.vue?vue&type=script&lang=js"
export * from "./BodySkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports